import { createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../Apis/apiRequest";


const apiSlice = createSlice({
  name: "api",
  initialState: {
//   courseswithouttoken:{data: null, loading: false, error: null},
   signOut:{data: null, loading: false, error: null},

 
  },
  reducers: {
    clearApiError: (state, action) => {
      const entity = action.payload;
      if (state[entity]) {
        state[entity].error = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(apiRequest.pending, (state, action) => {
        const { entity } = action.meta.arg;
        if (entity && !state[entity]) {
          state[entity] = { data: null, loading: false, error: null };
        }
        if (entity) {
          state[entity].loading = true;
          state[entity].error = null;
        }
      })
      .addCase(apiRequest.fulfilled, (state, action) => {
        const { entity, data } = action.payload;
        if (entity) {
          if (!state[entity]) {
            state[entity] = { data: null, loading: false, error: null };
          }
          state[entity].loading = false;
          state[entity].data = data;
        }
      })
      .addCase(apiRequest.rejected, (state, action) => {
        // التحقق من وجود entity في action.payload قبل استخراجه
        const entity = action.payload?.entity;
        if (entity) {
          if (!state[entity]) {
            state[entity] = { data: null, loading: false, error: null };
          }
          state[entity].loading = false;
          state[entity].error = action.payload.error;
        }
      });
  },
});

export let apiReducer = apiSlice.reducer;
export const { clearApiError } = apiSlice.actions;
